import {
    DeleteButton, SimpleForm, Button, Datagrid, List, TextField, BooleanField, Edit, TextInput, DateInput, DateTimeInput, ReferenceInput, ArrayInput, SimpleFormIterator,
    SelectInput, NumberInput, AutocompleteArrayInput, AutocompleteInput, TabbedForm, FormTab, ReferenceManyField, Pagination, Create, Show, Filter, FunctionField
} from "ra-ui-materialui";
import { useEffect, useState, useCallback } from "react";
import { getActivityType, getActivityTypeValue, getClientType, getLanguajes, getLikes, getTherapeuticProfile, getWorkingCenter, getProfessionalType, getReasonForCancellation } from "../services/master-tables.service";
import { InteractionDto, ScheduledActivityClient, AffinityClient, ExternalInformationClient, ProfessionalClient, ClientAffinityDto, CreateUpdateClientAffinityDto } from "../services/ohl.virtualCenter.api";
import { iconListFont } from "./icons.js"

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { parseDate } from "./scheduledActivities";
import { CustomActivityToolbarPermissions, PostBulkActionButtonsPermision } from "./utils";
import { FormDataConsumer, required, useRedirect, useMutation, useGetIdentity } from "ra-core";
import { ChipArrayUseStyles, TabsUseStyles } from "../App";
import { useFormState } from 'react-final-form';
import { WorkingCenterField } from "../components/Fields/WorkingCenterField";
import AutoCompleteCustom from "../components/AutoCompleteCustom"
import ActionDelete from '@material-ui/icons/Delete';
import { useLocation } from 'react-router';
import {
    useRefresh,
    useNotify,
    useUpdate,
    useRecordContext,
    DatagridBody,
    Labeled
} from "react-admin";
import { withStyles } from '@material-ui/core/styles';
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import AddIcon from "@material-ui/icons/Add";
import GroupIcon from "@material-ui/icons/Group";
import CalendarIcon from "@material-ui/icons/CalendarTodayRounded";
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { useForm } from 'react-final-form';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import StarPicker from 'react-star-picker';
import ReactQuill from 'react-quill';
import MUIButton from '@material-ui/core/Button';
import MUITabs from '@material-ui/core/Tabs';
import MUITab from '@material-ui/core/Tab';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import 'react-quill/dist/quill.snow.css';
import '../css/reactQuillMod.css';
import ReactHtmlParser from 'react-html-parser';
import '../css/user.css';
import { saveAs } from 'file-saver';
import { makeStyles } from '@material-ui/core/styles';
// import jsPDF from 'jspdf'
//// eslint-disable-next-line
// import autoTable from 'jspdf-autotable';
import jsonExport from 'jsonexport/dist';
import { downloadCSV } from "react-admin";

import scheduledActivitiesProvider from "../provider/scheduledActivities.provider";
import { CustomMultiSelect } from "../components/CustomMultiSelect";
import Affinity from "../components/Affinity/AffinityForm";



const interactionsClient = new ExternalInformationClient(process?.env?.REACT_APP_PUBLIC_API);
const professionalClient = new ProfessionalClient(process?.env?.REACT_APP_PUBLIC_API);
const scheduledActivityClient = new ScheduledActivityClient(process?.env?.REACT_APP_PUBLIC_API);
const affinityClient = new AffinityClient(process?.env?.REACT_APP_PUBLIC_API);
var XLSX = require("xlsx");

library.add(fas)

const validateActivityCreate = (values) => {
    const errors = {};
    if (!values?.name?.trim()) {
        errors.name = 'Requerido';
    }
    if (!values?.description?.trim()) {
        errors.description = 'Requerido';
    }
    if (!values?.initDate?.trim()) {
        errors.initDate = 'Requerido';
    }
    if (moment(values?.initDate).isBefore((new Date()).toDateString())) {
        errors.initDate = 'La fecha de inicio no puede ser anterior a la actual';
    }
    if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(values?.initHour)) {
        errors.initHour = 'Formato incorrecto';
    }
    if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(values?.endHour)) {
        errors.endHour = 'Formato incorrecto';
    }
    if (!values?.initHour?.trim()) {
        errors.initHour = 'Requerido';
    }
    if (!values?.endHour?.trim()) {
        errors.endHour = 'Requerido';
    }
    // Check initHour < endHour
    if (values.initHour && values.endHour) {
        const initDate = moment();
        const endDate = moment();
        initDate?.set({ hour: values?.initHour?.split(':')[0], minute: values?.initHour?.split(':')[1] })
        endDate?.set({ hour: values?.endHour.split(':')[0], minute: values?.endHour?.split(':')[1] })
        if (initDate >= endDate) {
            errors.endHour = 'No puede ser inferior a la fecha de inicio';
        }
    }
    if (!values?.periodicy?.trim()) {
        errors.periodicy = 'Requerido';
    }
    if (!values?.amount && values?.periodicy !== 'Once') {
        errors.amount = 'Requerido';
    }
    if (values?.amount <= 1 && values?.periodicy !== 'Once') {
        errors.amount = 'Tiene que ser mayor que 1';
    }
    if (!values?.participants || values?.participants?.length <= 0) {
        errors.participants = 'Requerido';
        errors.participantsValidation = 'Requerido';
    }
    if (!values?.professional || !values?.professional?.id) {
        errors.professional = { id: 'Requerido' };
    }
    /* if (!values.relatedContract?.id) {
        errors.relatedContract = { id: 'Requerido' }
    } */
    if (!values?.contracts?.length) {
        errors.contracts = 'Requerido';
        errors.contractsValidation = 'Requerido';
    }

    return errors
}

const ValidateEditAgenda = (values) => {
    const errors = {};

    let now = moment(new Date())
    let selected = moment(values?.startDate)
    if (selected < now) {
        errors.startDate = "La fecha no puede ser anterior a la actual"
    }

    return errors
}

const validateActivityEdit = (values) => {
    const errors = {};
    if (!values?.name?.trim()) {
        errors.name = 'Requerido';
    }
    if (!values?.description?.trim()) {
        errors.description = 'Requerido';
    }
    if (!values?.professional || !values?.professional?.id) {
        errors.professional = { id: 'Requerido' };
    }


    if (!values?.participants || values?.participants?.length <= 0) {
        errors.participants = 'Requerido';
        errors.participants = { id: 'Requerido' }
    }


    /*  if (values?.participants?.some(c => c === null || c === undefined)) {
         console.log(values?.participants)
         //errors.participants = 'Requerido';
         //errors.participantsValidation = 'Requerido';
 
         //errors.participants = 'Requerido';
         //errors.participantValidation = 'Requerido';
         //errors.participants = { id: 'Requerido' }
         const position = values?.participants?.findIndex(p => p === null || p === undefined);
 
         errors.participants = values.participants.map((participant, index) => ({
             ...errors.participants?.[index],
             id: index === position ? 'Requerido' : undefined,
         }));   
     }  */

    /*  if (!values?.relatedContract?.id) {
         errors.relatedContract = { id: 'Requerido' }
     } */
    if (!values?.contracts?.length) {
        errors.contracts = 'Requerido';
        errors.contractsValidation = 'Requerido';
    }
    return errors
}
const ActivitiesTitle = ({ record }) => {
    return <span>Actividad {record ? `${record?.name}` : ''}</span>;
};

const ActivitiesFilter = (props) => {
    const [languajeList, setlanguajeList] = useState()
    const [likeList, setlikeList] = useState()
    const [activityTypeList, setActivityTypeList] = useState()
    const [activitySubTypeList, setActivitySubTypeList] = useState()
    const [therapeuticalProfilesList, setTherapeuticalProfilesList] = useState()
    // const [clientTypes, setclientTypes] = useState()
    const chipClasses = ChipArrayUseStyles();
    const [workingCenter, setworkingCenter] = useState()
    const [professionalTypes, setprofessionalTypes] = useState()
    const { identity } = useGetIdentity();

    useEffect(() => {
        getLanguajes().then(
            res => {
                setlanguajeList(res?.elements);
            }
        )
        getLikes().then(
            res => {
                setlikeList(res?.elements);
            }
        )
        // getClientType().then(
        //     res => {
        //         setclientTypes(res.elements);
        //     }
        // )
        getWorkingCenter().then(
            res => {
                setworkingCenter(res?.elements);
            }
        )
        getActivityType().then(
            res => {
                setActivityTypeList(res?.elements);
            }
        )
        getActivityTypeValue().then(
            res => {
                setActivitySubTypeList(res?.elements);
            }
        )
        getTherapeuticProfile().then(
            res => {
                setTherapeuticalProfilesList(res?.elements);
            }
        )
        getProfessionalType().then(
            res => {
                setprofessionalTypes(res.elements);
            }
        )
    }, []);

    var filterType = ['SOCIAL_WORKER', 'PSYCHOLOGIST', 'TASOC', 'THERAPIST'];
    return (
        <Filter {...props}>
            <TextInput label="Nombre de actividad" source="name" alwaysOn />
            <TextInput label="Descripción" source="description" alwaysOn />
            <DateInput label="Fecha Desde" source="date" alwaysOn resettable={true} />
            <DateInput label="Fecha Hasta" source="endDate" alwaysOn resettable={true} />
            {/* <ReferenceInput label="ID" source="id" reference="activities" allowEmpty={false} perPage={100}>
                <AutocompleteInput optionText={(record) => record?.id + ""} resettable={true} />
            </ReferenceInput> */}
            <TextInput label="Id" source="id" defaultValue="" />
            
            <ReferenceInput label="Responsable" source="profesionalId" reference="professional" allowEmpty={false} perPage={100}
                filterToQuery={(searchText) => {
                    const baseFilter = {
                        professionalTypeId: professionalTypes
                            ?.filter(item => filterType.includes(item.value))
                            .map(item => item.id)
                    };

                    return searchText
                        ? { ...baseFilter, q: searchText } // Filtra este campo
                        : baseFilter;
                }}>
                <AutocompleteInput optionText={(record) => record?.identificationNumber + ' - ' + record?.name + ' ' + record?.surnames} resettable={true} />
            </ReferenceInput>
            <ReferenceInput label="Participante" source="clientId" reference="users" allowEmpty={false} perPage={100}
                filterToQuery={(value) => {
                    return { isMapperAll: false }
                }}>
                <AutocompleteInput optionText={(record) => record?.identificationNumber + ' - ' + record?.name + ' ' + record?.surnames} resettable={true} />
            </ReferenceInput>
            {
                likeList ?
                    <AutocompleteArrayInput
                        label="Gustos/Preferencias"
                        source="clientsLikesId"
                        choices={likeList}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        className="full"
                        classes={chipClasses}
                        allowEmpty={false}
                    />
                    : null
            }
            {/* {
                clientTypes ?
                    <AutocompleteInput
                        label="Tipo usuario"
                        source="clientTypeId"
                        choices={clientTypes}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        classes={chipClasses}
                        resettable={true}
                    />
                    : null
            } */}
            {
                languajeList ?
                    <AutocompleteInput
                        label="Idioma"
                        source="languageId"
                        choices={languajeList}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        classes={chipClasses}
                        resettable={true}
                    />
                    : null
            }
            {
                workingCenter ?
                    <AutocompleteInput
                        label="Centro de Trabajo"
                        source="associatedWorkingCenterId"
                        choices={workingCenter}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        resettable={true}
                    />
                    : null
            }
            {
                activityTypeList ?
                    <AutocompleteArrayInput
                        label="Tipo de actividad"
                        source="primaryTypeList"
                        choices={activityTypeList}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        className="full"
                        classes={chipClasses}
                        allowEmpty={false}
                    />
                    : null
            }
            {
                activitySubTypeList ?
                    <AutocompleteArrayInput
                        label="Subtipo de actividad"
                        source="secondaryTypeList"
                        choices={activitySubTypeList}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        className="full"
                        classes={chipClasses}
                        allowEmpty={false}
                    />
                    : null
            }
            {
                therapeuticalProfilesList ?
                    <AutocompleteArrayInput
                        label="Perfil Terapéutico"
                        source="therapeuticalProfileIds"
                        choices={therapeuticalProfilesList}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        className="full"
                        classes={chipClasses}
                        allowEmpty={false}
                    />
                    : null
            }
            <ReferenceInput
                label="Contratos"
                source="contractId"
                reference="contracts"
                perPage={100}
                resettable={true}
                filterToQuery={(value) => {
                    return { contractNumber: value }
                }}
            >
                <AutocompleteInput optionText={(record) => record?.contractNumber} />
            </ReferenceInput>
            {
                identity?.roles === "SUPER_ADMIN" ?
                    <SelectInput label="Eliminadas" source="isDeleted" choices={[
                        { id: 'all', name: 'Ambas' },
                        { id: 'false', name: 'No eliminadas' },
                        { id: 'true', name: 'Eliminadas' }
                    ]} /> : null
            }

        </Filter>
    );
}

export const ActivityList = props => {


    const { identity, loading } = useGetIdentity();
    const [languageList, setLanguageList] = useState();
    const [workingCenterList, setWorkingCenterList] = useState();

    const useStyles = makeStyles((theme) => ({
        paper: {
            border: '1px solid',
            padding: theme.spacing(1),
            backgroundColor: theme?.palette?.background?.paper,
        },
    }));
    const [activitiesList, setActivitiesList] = useState();
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        getLanguajes().then(
            res => {
                setLanguageList(res?.elements);
            }
        )
        getWorkingCenter().then(
            res => {
                setWorkingCenterList(res?.elements);
            }
        )
    }, []);


    const customExporter = async (data, fetchRelatedRecords, dataProvider) => {
        const pageSize = 1000;
        let currentPage = 2;
        let allData = [...data]; // Comenzamos con los datos ya cargados en la vista
        let hasMoreData = true;

        const variable = '';

        if (data.length === pageSize) {

            try {
                // Mientras haya más datos por cargar (cuando las páginas traen registros)
                while (hasMoreData) {
                    const { data: pageData } = await dataProvider.getList('activities', {
                        filter: { ...variable },
                        pagination: { page: currentPage, perPage: pageSize },
                        sort: { field: 'id', order: 'ASC' },
                    });

                    allData = [...allData, ...pageData];

                    if (pageData.length < pageSize) {
                        hasMoreData = false;
                    }

                    currentPage += 1;

                    console.log(`Página ${currentPage - 1} descargada. Total de registros descargados: ${allData.length}`);
                }

                console.log('Exportación completa. Total de datos:', allData.length);

            } catch (error) {
                console.error('Error durante la exportación con paginación:', error);
            }
        }

        exporter(allData);

    };

    const exporter = activities => {
        // if (!isOpen) {
        //     setIsOpen(true);
        // }
        setIsOpen(false);
        let activityList = activities.map(post => {
            const { icon, clientsLikesId, clientTypeId, secondaryTypeId, primaryTypeId, languageId, contracts, ...activityElement } = post;
            // activityElement.startDate = moment(activityElement.startDate[0]).utc().format('DD-MM-yyyy HH:mm');
            let startDates = [...activityElement?.startDate];
            let participants = [...activityElement?.participants];
            let professional = { ...activityElement?.professional };
            //let contract = { ...activityElement?.relatedContract };
            activityElement.professional = professional?.name + " " + professional?.surnames;
            activityElement.participants = '';
            //activityElement.contractNumber = contract?.contractNumber;
            participants.forEach((participant, index) => {
                let commaOrNot = index === participants?.length - 1 ? '' : ' , ';
                activityElement.participants += participant?.name + " " + participant?.surnames + commaOrNot;
            })
            activityElement.startDate = '';
            startDates.forEach((startDate, index) => {
                let commaOrNot = index === startDates?.length - 1 ? '' : ' , ';
                activityElement.startDate += moment(startDate).utc().format('DD-MM-yyyy HH:mm').toString() + commaOrNot;
            });
            if (activityElement.languageId) {
                let language = languageList?.filter(language => language?.id === activityElement?.languageId);
                if (language && language?.length > 0) {
                    activityElement.languageId = language[0]?.value;
                }
            }
            if (activityElement.associatedWorkingCenterId) {
                let workingCenter = workingCenterList.filter(workingcenter => workingcenter?.id === activityElement?.associatedWorkingCenterId);
                if (workingCenter && workingCenter?.length > 0) {
                    activityElement.associatedWorkingCenterId = workingCenter[0]?.value;
                }
            }
            if (contracts && contracts.length > 0) {

                let contractValues = contracts.map(contract => contract?.contractNumber);

                let contractString = contractValues.join(",");

                activityElement.contracts = contractString;
            }
            return activityElement;
        });
        activityList = translateHeaders(activityList);
        setActivitiesList(activityList);
        const xlsxBlob = arrayToXlsx(activityList);
        saveAs(xlsxBlob, 'actividades.xlsx');
    };

    const saveExcelFile = () => {
        const xlsxBlob = arrayToXlsx(activitiesList);
        saveAs(xlsxBlob, 'actividades.xlsx');
    };

    // const savePdfFile = () => {
    //     const unit = "pt";
    //     const size = "A4"; // Use A1, A2, A3 or A4
    //     const orientation = "landscape"; // portrait or landscape

    //     const marginLeft = 40;
    //     const doc = new jsPDF(orientation, unit, size);

    //     doc.setFontSize(12);

    //     const title = "Actividades";
    //     const headers = [["Nombre", "Descripción", "Responsable", "Fecha Actividad", "Participante(s)", "Centro Trabajo", "Recursiva"]];

    //     const data = activitiesList.map(elt => [elt['Nombre'], elt['Descripción'], elt['Responsable'], elt['Fecha Actividad'],
    //     elt['Participante(s)'], elt['Centro Trabajo'], elt['Recursiva']]);

    //     let content = {
    //         startY: 50,
    //         head: headers,
    //         body: data
    //     };

    //     doc.text(title, marginLeft, 40);
    //     doc.autoTable(content);
    //     doc.save("actividades.pdf")
    // };

    const saveCsvFile = () => {
        jsonExport(activitiesList, {
            headers: ["Nombre", "Descripción", "Responsable", "Fecha Actividad", "Participante(s)", "Centro Trabajo", "Recursiva"] // order fields in the export
        }, (err, csv) => {
            downloadCSV(csv, 'actividades');
        });
    };

    const arrayToXlsx = (array) => {
        const worksheet = XLSX.utils.json_to_sheet(array);
        worksheet["!cols"] = [{ wch: 30 }, { wch: 40 }, { wch: 26 }, { wch: 16 }, { wch: 35 }, /*{ wch: 10 },*/ { wch: 14 }, { wch: 10 }];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const xlsxBlob = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        return new Blob([xlsxBlob], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    };
    const translateHeaders = (activitiesList) => {
        for (let i = 0; i < activitiesList?.length; i++) {
            activitiesList[i]['Id'] = activitiesList[i]['id'];
            delete activitiesList[i]['id'];
            activitiesList[i]['Nombre'] = activitiesList[i]['name'];
            delete activitiesList[i]['name'];
            activitiesList[i]['Descripción'] = activitiesList[i]['description'];
            delete activitiesList[i]['description'];
            activitiesList[i]['Responsable'] = activitiesList[i]['professional'];
            delete activitiesList[i]['professional'];
            activitiesList[i]['Fecha Actividad'] = activitiesList[i]['startDate'];
            delete activitiesList[i]['startDate'];
            activitiesList[i]['Participante(s)'] = activitiesList[i]['participants'];
            delete activitiesList[i]['participants'];
            // activitiesList[i]['Idioma'] = activitiesList[i]['languageId'];
            // delete activitiesList[i]['languageId'];
            activitiesList[i]['Centro Trabajo'] = activitiesList[i]['associatedWorkingCenterId'];
            delete activitiesList[i]['associatedWorkingCenterId'];
            activitiesList[i]['Recursiva'] = activitiesList[i]['scheduledActivitiesId'].length > 1 ? "Si" : "No";
            delete activitiesList[i]['scheduledActivitiesId'];
            delete activitiesList[i]['location'];
            delete activitiesList[i]['comments'];
            delete activitiesList[i]['isRecord'];
            activitiesList[i]['Tipo'] = activitiesList[i]['primaryTypeDescription'];
            delete activitiesList[i]['primaryTypeDescription'];
            activitiesList[i]['SubTipo'] = activitiesList[i]['secondaryTypeDescription'];
            delete activitiesList[i]['secondaryTypeDescription'];
            activitiesList[i]['Contratos'] = activitiesList[i]['contracts'];
            delete activitiesList[i]['contracts'];
            delete activitiesList[i]['contractNumber'];
            delete activitiesList[i]['relatedContract'];
            activitiesList[i]['Estado'] = activitiesList[i]['status'];
            delete activitiesList[i]['status'];
            if (identity.roles === "SUPER_ADMIN") activitiesList[i]['Eliminada'] = activitiesList[i]['isDeleted'] === true ? "Si" : "No";
            delete activitiesList[i]['isDeleted'];
            activitiesList[i]['Recursiva'] = activitiesList[i]['recursive'];
            delete activitiesList[i]['recursive'];
            delete activitiesList[i]['contracts'];

        }
        return activitiesList;
    }

    if (loading && !identity) {
        return <div></div>;
    }
    return (
        // <div onClick={() => setIsOpen(false)}>
        <>
            <List bulkActionButtons={props?.permissions?.activities?.delete ? <PostBulkActionButtonsPermision perm="activities.delete" /> : false}
                filters={<ActivitiesFilter />}
                exporter={identity.roles === "CONTRACTING_AUTHORITY" ? false : (data, fetchRelatedRecords, dataProvider) => customExporter(data, fetchRelatedRecords, dataProvider)}
                sort={{ field: 'id', order: 'DESC' }}
                {...props}>
                <Datagrid
                    rowClick={record => record?.isDeleted ? "show" : (props?.permissions?.activities?.edit ? "edit" : "show")}
                    isRowSelectable={record => !record?.isDeleted && props?.permissions?.activities?.delete}
                /* isRowSelectable={record => !record?.isDeleted && props?.permissions?.activities?.delete}
                rowStyle={record => ({
                    pointerEvents: record?.isDeleted ? "none" : "auto",
                })} */>
                    <TextField label="Id" source="id" />
                    <TextField label="Nombre Actividad" source="name" />
                    <TextField label="Descripción" source="description" />
                    <TextField label="Responsable" source="professional.name" sortable={true} />
                    <FunctionField style={{ whiteSpace: 'nowrap' }} label="Fecha Actividad"
                        className="capitalize" sortable={true} sortBy="ScheduledActivities.StartDate"
                        render={record => ReactHtmlParser(record?.startDate?.map(d => parseDate(d)).slice(0, 3).join('<br>'))}
                    />
                    <FunctionField style={{ width: 150 }} label="Participante(s)" className="capitalize" sortable={true}
                        sortBy="Participants.Name"
                        render={record => {
                            let arr = record?.participants?.map(p => `${p?.name} ${p?.surnames}`)
                            return ReactHtmlParser(arr?.slice(0, 3).join('<br>') + (arr?.length > 3 ? '...' : ''))
                        }}
                    />
                    <WorkingCenterField label="Centro de Trabajo" source="associatedWorkingCenterId" sortable={true} sortBy="WorkingCenter.Name" />
                    <TextField label="Tipo" source="primaryTypeDescription" />
                    <TextField label="SubTipo" source="secondaryTypeDescription" />
                    <FunctionField label="Contrato" sortBy="contracts.ContractNumber"
                        render={record => {
                            let arr = record?.contracts?.map(p => p?.contractNumber)
                            return ReactHtmlParser(arr?.slice(0, 3).join('<br>') + (arr?.length > 3 ? '...' : ''))
                        }}
                    />
                    <TextField label="Estado" source="status" sortable={true} />
                    <TextField label="Recursiva" source="recursive" sortable={true} />
                    {
                        identity.roles === "SUPER_ADMIN" ? <FunctionField sortable={true} source="isDeleted" label="Eliminada" render={record => `${record?.isDeleted ? "SI" : ""}`} /> : null
                    }
                </Datagrid>
            </List>
            {isOpen && (
                <div style={{ position: 'fixed', top: '6rem', right: '6rem', zIndex: 1000 }}
                    id="tooltip"
                    className={classes.paper}
                >
                    <MUIButton variant="outlined" color="secondary" onClick={() => saveExcelFile()}>Excel</MUIButton>
                    <MUIButton variant="outlined" color="secondary" onClick={() => saveCsvFile()}>CSV</MUIButton>
                    {/* <MUIButton variant="outlined" color="secondary" onClick={() => savePdfFile()}>PDF</MUIButton> */}
                </div>
            )}
        </>
    )
};


export const ActivityEdit = (props) => {

    return (
        <Edit title={<ActivitiesTitle />} mutationMode="pessimistic" {...props} transform={transformActivitiesUpdate}>
            {ActivityForm(props, 'edit')}
        </Edit>
    )
};

export const ActivityCreate = (props) => {

    return (
        <Create mutationMode="pessimistic" {...props} transform={transformActivitiesCreate}>
            {ActivityForm(props)}
        </Create>
    )
};

export const ActivityShow = props => (
    <Show title={<ActivitiesTitle />} {...props}>
        {ActivityShowForm(props)}
    </Show>
);

const DisabledWrapper = ({ record, applyStyle, children }) => {

    const { values } = useFormState();
    const disabled = values?.isDeleted; // Deshabilita si el registro está eliminado

    return (
        <div className={applyStyle ? 'custom-activity-delete' : ''}>

            {React.Children.map(children, (child) => {
                if (!React.isValidElement(child)) return child;

                return React.cloneElement(child, {
                    disabled: child.props.disabled || disabled,
                });
            })}
        </div>
    );

};

const ActivityForm = (props, mode = 'create') => {

    const [languajeList, setlanguajeList] = useState()
    const [workingCenter, setworkingCenter] = useState();
    const [activityType, setactivityType] = useState();
    const [likeList, setlikeList] = useState();
    // const [clientTypes, setclientTypes] = useState()
    const [iconList, seticonList] = useState();
    const classes = TabsUseStyles();
    const [professionalTypes, setprofessionalTypes] = useState();
    const [reasonForCancellationList, setReasonForCancellationList] = useState();

    useEffect(() => {
        getLanguajes().then(
            res => {
                setlanguajeList(res.elements);
            }
        )
        getLikes().then(
            res => {
                setlikeList(res.elements);
            }
        )
        getClientType().then(
            res => {
                // setclientTypes(res.elements);
            }
        )
        getWorkingCenter().then(
            res => {
                setworkingCenter(res.elements);
            }
        )
        getActivityType().then(
            res => {
                setactivityType(res.elements);
            }
        )
        getProfessionalType().then(
            res => {
                setprofessionalTypes(res.elements);
            }
        )
        getReasonForCancellation().then(
            res => {
                setReasonForCancellationList(res.elements);
            }
        )
        seticonList(iconListFont)

    }, []);

    const redirect = useRedirect();
    const notify = useNotify()
    const [mutate] = useMutation();
    const { identity, loading } = useGetIdentity();
    const save = useCallback(
        async (values) => {
            try {
                const res = await mutate({
                    type: mode === 'create' ? 'create' : 'update',
                    resource: 'activities',
                    payload: { data: mode === 'create' ? transformActivitiesCreate(values) : transformActivitiesUpdate(values) },
                }, { returnPromise: true });
                notify(`ra.notification.${mode === 'create' ? 'created' : 'updated_item'}`)
                if (mode === 'create') {
                    redirect('edit', props?.basePath, res?.data?.id, res?.data)
                } else {
                    redirect('list', props?.basePath)
                }
            } catch (error) {
                if (error?.error && error?.error?.code === 4003) {
                    notify(error?.error?.message, 'error')
                    // return {
                    //     professional: { id: error.error.message }
                    // };
                }
                if (error?.error && error?.error?.code === 4001) {
                    notify(error?.error?.message, 'error')
                    // return {
                    //     contractNumber: error.error.message
                    // };
                }
                //notify('ra.notification.http_error', 'warning')
            }
        },
        [mutate, mode, notify, props.basePath, redirect],
    );


    const CustomDatagridRow = ({ record, resource, id, onToggleItem, children, selected, basePath }) => (
        <TableRow key={id}>
            {React.Children.map(children, field => (
                <TableCell style={{ width: field?.props?.width }} key={`${id}-${field?.props?.source}`}>
                    {React.cloneElement(field, {
                        record,
                        basePath,
                        resource,
                    })}
                </TableCell>
            ))}
        </TableRow>
    );


    const CustomDatagridBody = props => <DatagridBody {...props} row={<CustomDatagridRow />} />;
    const CustomDatagrid = props => <Datagrid {...props} body={<CustomDatagridBody />} />;
    if (loading && !identity) {
        return <div></div>;
    }
    return (
        <TabbedForm toolbar={<CustomActivityToolbarPermissions perm="activities.delete" />} classes={classes} save={save} validate={mode === 'create' ? validateActivityCreate : validateActivityEdit}>
            <FormTab label="Actividad" >
                <DisabledWrapper record={{ ...props }} applyStyle={true}>

                    {
                        mode === 'edit' && (
                            <TextInput
                                disabled={true}
                                label="Id"
                                source="id" />
                        )
                    }
                    <TextInput
                        disabled={props?.isDeleted}
                        label="Nombre Actividad"
                        source="name"
                    />

                    <TextInput
                        disabled={props?.isDeleted}
                        label="Descripción" source="description" />
                    {/* <ReferenceInput
                        label="Contrato"
                        disabled={props?.isDeleted}
                        source="relatedContract.id"
                        reference="contracts"
                        perPage={1000}
                        filterToQuery={(value) => {
                            return { nameINumber: value }
                        }}
                    >
                        <AutocompleteInput
                            disabled={props?.isDeleted}
                            optionText={(record) => record?.contractNumber} resettable={true} />
                    </ReferenceInput> */}
                    <ContractProfessionalsInput professionalTypes={professionalTypes} source="professional.id" disabled={props?.isDeleted}></ContractProfessionalsInput>
                    {
                        iconList ?
                            <AutocompleteInput
                                label="Icono"
                                source="icon"
                                choices={iconList}
                                disabled={props?.isDeleted}
                                // optionText="value"
                                optionText={<OptionIconRenderer />}
                                inputText={choice => `${choice?.value}`}
                                matchSuggestion={(filterValue, suggestion) => {
                                    return suggestion ? suggestion?.value?.includes(filterValue) : false
                                }}
                                optionValue="value"
                                // resettable={true}
                                suggestionLimit={25}
                                options={{ InputProps: { autoComplete: 'off' } }}
                                resettable={true}
                            />
                            : null
                    }
                    {
                        likeList && <CustomMultiSelect valuesList={likeList} label="Gustos/Preferencias" property="clientsLikesId" />
                    }
                    {/* {
                    clientTypes ?
                        <AutocompleteInput
                            label="Perfil de usuario"
                            source="clientTypeId"
                            choices={clientTypes}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            classes={chipClasses}
                            resettable={true}
                        />
                        : null
                } */}
                    {
                        languajeList ?
                            <AutocompleteInput
                                label="Idioma"
                                source="languageId"
                                choices={languajeList}
                                disabled={props?.isDeleted}
                                optionText="value"
                                optionValue="id"
                                options={{ InputProps: { autoComplete: 'off' } }}
                                resettable={true}
                            />
                            : null
                    }
                    {
                        workingCenter ?
                            <AutocompleteInput
                                label="Centro de Trabajo"
                                source="associatedWorkingCenterId"
                                choices={workingCenter}
                                disabled={props?.isDeleted}
                                optionText="value"
                                optionValue="id"
                                options={{ InputProps: { autoComplete: 'off' }, autoComplete: 'off' }}
                                resettable={true}
                            />
                            : null
                    }
                    {
                        activityType ?
                            <AutocompleteInput
                                label="Tipología dinámica"
                                source="primaryTypeId"
                                choices={activityType}
                                disabled={props?.isDeleted}
                                optionText="value"
                                optionValue="id"
                                options={{ InputProps: { autoComplete: 'off' }, autoComplete: 'off' }}
                                resettable={true}
                                validate={[required()]}
                            />
                            : null
                    }
                    <ActivityTypeValueInput source="typeValue" disabled={props?.isDeleted} mode={mode}></ActivityTypeValueInput>
                </DisabledWrapper>

            </FormTab>
            <FormTab label="Contratos">
                <DisabledWrapper record={{ ...props }} applyStyle={false}>
                    <ContractsInput source="id" mode={mode} ></ContractsInput>
                    <TextInput disabled={props?.isDeleted} style={{ display: 'none' }} source="contractsValidation" />
                </DisabledWrapper>
            </FormTab>
            <FormTab label="Participantes">
                <DisabledWrapper record={{ ...props }} applyStyle={false}>
                    <ContractParticipantsInput source="id" mode={mode} ></ContractParticipantsInput>
                    <TextInput disabled={props?.isDeleted} style={{ display: 'none' }} source="participantsValidation" />
                </DisabledWrapper>
            </FormTab>
            {
                mode === 'edit' ?
                    <FormTab label="Agenda" contentClassName="">
                        <ReferenceManyField
                            className="full"
                            pagination={<Pagination />}
                            addLabel={false}
                            target="id"
                            reference="scheduledActivities"
                            perPage={10}
                            filter={{ IncludeCanceled: true, IncludeUnRealized: true }}
                        >
                            <CustomDatagrid className="full">
                                <TextField width="25%" label="Nombre actividad" source="activity.name" />
                                {/* <DateField label="Fecha inicio" source="startDate" /> */}
                                <FunctionField width="15%" label="Fecha inicio" className="capitalize" render={record => parseDate(record?.startDate)} />
                                <FunctionField width="15%" label="Fecha Fin" className="capitalize" render={record => parseDate(record?.endDate)} />
                                <span></span>
                                <FunctionField width="10%" label="Estado" className="state" render={record => {
                                    return record.stateName
                                }} />
                                {
                                    identity.roles === "SUPER_ADMIN" ?
                                        <BooleanField style={{justifyContent: "center"}} width="2rem" label="Eliminada" source="isDeleted" /> :
                                        <span></span>
                                }

                                {/* <BooleanField label="Cancelada" source="isCancel" />
                                <BooleanField label="Comenzada" source="isHeld" />
                                <FunctionField label="Realizada" render={record => {
                                    return !!record.realEndDate ? <Done color="primary" /> : <Clear />
                                }} /> */}
                                <FunctionField label="" render={record => {
                                    return record?.stateName !== "No realizada" && !record?.isDeleted && !record?.isCancel && !record?.isHeld && !record?.realEndDate && props?.permissions && props?.permissions?.activities?.edit ?
                                        <>
                                            <EditScheduledActivityButton record={record} identity={identity} loading={loading} />
                                        </> : null
                                }} />
                                <FunctionField label="" render={record => {
                                    return record?.stateName !== "No realizada" && !record?.isDeleted && record?.isHeld && record?.realEndDate && props?.permissions && props?.permissions?.activities?.edit ?
                                        <>
                                            < EditActivityCommentButton record={record} identity={identity} loading={loading} />
                                        </> : null
                                }} />      
                                <FunctionField label="" render={record => {
                                    return record?.stateName !== "No realizada" && !record?.isDeleted && !record?.isCancel && !record?.isHeld && !record?.realEndDate && props?.permissions ? <CancelScheduledActivityButton record={record} identity={identity} loading={loading} reasonForCancellationList={reasonForCancellationList} /> : null
                                }} />     
                                <FunctionField  width="20%" label="" render={record => {
                                    return record?.stateName !== "No realizada" && record?.isCancel ? "Motivo de cancelación: " + reasonForCancellationList?.find(f => f?.id === record?.reasonForCancellationId).value : null
                                }} />              
                                <FunctionField label="" render={record => {
                                    return record?.stateName !== "No realizada" && !record?.isDeleted && !record?.isCancel && !record?.isHeld && !record?.realEndDate && props?.permissions && props?.permissions?.activities?.delete ? <DeleteScheduledActivityButton record={record} identity={identity} loading={loading} /> : null
                                }} />
                                
                            </CustomDatagrid>
                        </ReferenceManyField >
                    </FormTab>
                    :
                    <FormTab label="Periodicidad" contentClassName="tab-container">
                        <DateInput label="Fecha de inicio" source="initDate" validate={[required()]}></DateInput>
                        <div style={{ width: '98%' }}>
                            <TextInput style={{ marginRight: 5 }} label="Hora inicio (HH:MM)" source="initHour" validate={[required()]} ></TextInput>
                            <TextInput style={{ marginLeft: 5 }} label="Hora fin (HH:MM)" source="endHour" validate={[required()]} ></TextInput>
                        </div>
                        <SelectInput label="Periodicidad" source="periodicy" choices={[
                            { id: 'Once', name: 'Una vez' },
                            { id: 'EveryWeek', name: 'Cada semana' },
                            { id: 'EveryMonth', name: 'Cada Mes' },
                            { id: 'EveryYear', name: 'Cada año' },
                        ]} required />
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData?.periodicy !== 'Once' &&
                                <NumberInput label="Cantidad de eventos" source="amount" validate={[validateCustom(formData?.periodicy)]} required></NumberInput>
                            }
                        </FormDataConsumer>
                    </FormTab>
            }
        </TabbedForm >

    )
}



export const validateCustom = (typePeriodicy) => {

    const EveryDayLimit = 365;
    const EveryWeekLimit = 52;
    const EveryMonthLimit = 24;
    const EveryYeaLimitr = 2;

    return (value) => {
        switch (typePeriodicy) {
            case 'EveryDay':
                return value > EveryDayLimit
                    ? `El límite para la periodicidad diaria es ${EveryDayLimit}`
                    : undefined;
            case 'EveryWeek':
                return value > EveryWeekLimit
                    ? `El límite para la periodicidad semanal es ${EveryWeekLimit}`
                    : undefined;
            case 'EveryMonth':
                return value > EveryMonthLimit
                    ? `El límite para la periodicidad mensual es ${EveryMonthLimit}`
                    : undefined;
            case 'EveryYear':
                return value > EveryYeaLimitr
                    ? `El límite para la periodicidad anual es ${EveryYeaLimitr}`
                    : undefined;
            default:
                return undefined;
        }
    };
};

const ActivityShowForm = (props, mode = 'show') => {
    const [languajeList, setlanguajeList] = useState()
    const [workingCenter, setworkingCenter] = useState();
    const [activityType, setactivityType] = useState();
    const [likeList, setlikeList] = useState()
    // const [clientTypes, setclientTypes] = useState()
    const [iconList, seticonList] = useState()
    const classes = TabsUseStyles();
    const chipClasses = ChipArrayUseStyles();
    const [professionalTypes, setprofessionalTypes] = useState()
    const [reasonForCancellationList, setReasonForCancellationList] = useState();



    useEffect(() => {
        getLanguajes().then(
            res => {
                setlanguajeList(res.elements);
            }
        )
        getLikes().then(
            res => {
                setlikeList(res.elements);
            }
        )
        getClientType().then(
            res => {
                // setclientTypes(res.elements);
            }
        )
        getWorkingCenter().then(
            res => {
                setworkingCenter(res.elements);
            }
        )
        getActivityType().then(
            res => {
                setactivityType(res.elements);
            }
        )
        getProfessionalType().then(
            res => {
                setprofessionalTypes(res.elements);
            }
        )        
        getReasonForCancellation().then(
            res => {
                setReasonForCancellationList(res.elements);
            }
        )
        seticonList(iconListFont)

    }, []);

    const redirect = useRedirect();
    const notify = useNotify()
    const [mutate] = useMutation();
    const { identity, loading } = useGetIdentity();
    const save = useCallback(
        async (values) => {
            try {
                const res = await mutate({
                    type: mode === 'create' ? 'create' : 'update',
                    resource: 'activities',
                    payload: { data: mode === 'create' ? transformActivitiesCreate(values) : transformActivitiesUpdate(values) },
                }, { returnPromise: true });
                notify(`ra.notification.${mode === 'create' ? 'created' : 'updated_item'}`)
                if (mode === 'create') {
                    redirect('edit', props?.basePath, res?.data?.id, res.data)
                } else {
                    redirect('list', props?.basePath)
                }
            } catch (error) {
                if (error?.error && error?.error?.code === 4003) {
                    notify(error?.error?.message, 'error')
                    return {
                        professional: { id: error?.error?.message }
                    };
                }
                if (error?.error && error?.error?.code === 4001) {
                    notify(error?.error?.message, 'error')
                    return {
                        contractNumber: error?.error?.message
                    };
                }
                notify('ra.notification.http_error', 'warning')
            }
        },
        [mutate, mode, notify, props.basePath, redirect],
    );

    const CustomDatagridRow = ({ record, resource, id, onToggleItem, children, selected, basePath }) => (
        <TableRow key={id}>
            {React.Children.map(children, field => (
                <TableCell style={{ width: field?.props?.width }} key={`${id}-${field?.props?.source}`}>
                    {React.cloneElement(field, {
                        record,
                        basePath,
                        resource,
                    })}
                </TableCell>
            ))}
        </TableRow>
    );

    const CustomDatagridBody = props => <DatagridBody {...props} row={<CustomDatagridRow />} />;
    const CustomDatagrid = props => <Datagrid {...props} body={<CustomDatagridBody />} />;

    return (
        <TabbedForm toolbar={null} classes={classes} save={save} validate={mode === 'create' ? validateActivityCreate : validateActivityEdit}>
            <FormTab label="Actividad" contentClassName="tab-container">
                <TextInput label="Nombre Actividad" source="name" />
                <TextInput label="Descripción" source="description" />
                {/* <ReferenceInput
                    label="Contrato"
                    source="relatedContract.id"
                    reference="contracts"
                    perPage={100}
                    filterToQuery={(value) => {
                        return { contractNumber: value }
                    }}
                >
                    <AutocompleteInput optionText={(record) => record?.contractNumber} resettable={true} />
                </ReferenceInput> */}
                <ContractProfessionalsInput professionalTypes={professionalTypes} source="professional.id" disabled="true"></ContractProfessionalsInput>
                {/* <TextInput label="Icono" source="icon" /> */}
                {
                    iconList ?
                        <AutocompleteInput
                            label="Icono"
                            source="icon"
                            choices={iconList}
                            // optionText="value"
                            optionText={<OptionIconRenderer />}
                            inputText={choice => `${choice?.value}`}
                            matchSuggestion={(filterValue, suggestion) => {
                                return suggestion ? suggestion?.value?.includes(filterValue) : false
                            }}
                            optionValue="value"
                            // resettable={true}
                            suggestionLimit={25}
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                        />
                        : null
                }
                {
                    likeList ?
                        <AutocompleteArrayInput
                            label="Gustos/Preferencias"
                            source="clientsLikesId"
                            choices={likeList}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            className="full"
                            classes={chipClasses}
                        />
                        : null
                }
                {/* {
                    clientTypes ?
                        <AutocompleteInput
                            label="Perfil de usuario"
                            source="clientTypeId"
                            choices={clientTypes}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            classes={chipClasses}
                            resettable={true}
                        />
                        : null
                } */}
                {
                    languajeList ?
                        <AutocompleteInput
                            label="Idioma"
                            source="languageId"
                            choices={languajeList}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                        />
                        : null
                }
                {
                    workingCenter ?
                        <AutocompleteInput
                            label="Centro de Trabajo"
                            source="associatedWorkingCenterId"
                            choices={workingCenter}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' }, autoComplete: 'off' }}
                            resettable={true}
                        />
                        : null
                }
                {
                    activityType ?
                        <AutocompleteInput
                            label="Tipología dinámica"
                            source="primaryTypeId"
                            choices={activityType}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' }, autoComplete: 'off' }}
                            resettable={true}
                        />
                        : null
                }
                <ActivityTypeValueInput source="typeValue" mode={mode}></ActivityTypeValueInput>
            </FormTab>
            <FormTab label="Contratos">
                <ContractsInput source="id" disabled={true} mode={mode} ></ContractsInput>
                <TextInput disabled={true} style={{ display: 'none' }} source="contractsValidation" />
            </FormTab>
            <FormTab label="Participantes">
                <ContractParticipantsInput source="id" mode={mode} ></ContractParticipantsInput>
                <TextInput style={{ display: 'none' }} source="participantsValidation" />
            </FormTab>
            {
                mode === 'edit' ?
                    <FormTab label="Agenda" contentClassName="">
                        <ReferenceManyField
                            pagination={<Pagination />}
                            addLabel={false}
                            target="id"
                            reference="scheduledActivities"
                            perPage={10}
                            filter={{ IncludeCanceled: true, IncludeUnRealized: true }}
                        >
                            <CustomDatagrid>
                                <TextField width="2rem" label="Nombre actividad" source="activity.name" />
                                {/* <DateField label="Fecha inicio" source="startDate" /> */}
                                <FunctionField label="Fecha inicio" className="capitalize" render={record => parseDate(record?.startDate)} />
                                <span></span>
                                <FunctionField style={{ width: "2rem" }} label="Estado" className="state" render={record => {
                                    return record.stateName
                                }} />
                                <span></span>
                                {/* <BooleanField label="Cancelada" source="isCancel" />
                                <BooleanField label="Comenzada" source="isHeld" />
                                <FunctionField label="Realizada" render={record => {
                                    return !!record.realEndDate ? <Done color="primary" /> : <Clear />
                                }} /> */}
                                <FunctionField label="" render={record => {
                                    return record?.stateName !== "No realizada" && !record?.isCancel && !record?.isHeld && !record?.realEndDate && props?.permissions && props?.permissions?.activities?.edit ? <EditScheduledActivityButton record={record} identity={identity} loading={loading} /> : null
                                }} />
                                <FunctionField  width="20%" label="" render={record => {
                                    return record?.stateName !== "No realizada" && record?.isCancel ? "Motivo de cancelación: " + reasonForCancellationList?.find(f => f?.id === record?.reasonForCancellationId).value : null
                                }} />   
                                <FunctionField label="" render={record => {
                                    return record?.stateName !== "No realizada" && !record?.isCancel && !record?.isHeld && !record?.realEndDate && props?.permissions && props?.permissions?.activities?.delete ? <DeleteScheduledActivityButton record={record} identity={identity} loading={loading} /> : null
                                }} />
                            </CustomDatagrid>
                        </ReferenceManyField >
                    </FormTab>
                    :
                    <FormTab label="Periodicidad" contentClassName="tab-container">
                        <DateInput label="Fecha de inicio" source="initDate"></DateInput>
                        <div style={{ width: '98%' }}>
                            <TextInput style={{ marginRight: 5 }} label="Hora inicio (HH:MM)" source="initHour" ></TextInput>
                            <TextInput style={{ marginLeft: 5 }} label="Hora fin (HH:MM)" source="endHour" ></TextInput>
                        </div>
                        <SelectInput label="Periodicidad" source="periodicy" choices={[
                            { id: 'Once', name: 'Una vez' },
                            { id: 'EveryWeek', name: 'Cada semana' },
                            { id: 'EveryMonth', name: 'Cada Mes' },
                            { id: 'EveryYear', name: 'Cada año' },
                        ]} />
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData?.periodicy !== 'Once' &&
                                <NumberInput label="Cantidad de eventos" source="amount"></NumberInput>
                            }
                        </FormDataConsumer>
                    </FormTab>
            }
        </TabbedForm>
    )
}

const EditScheduledActivityButton = (props) => {
    const [showDialog, setshowDialog] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const record = useRecordContext(props);

    const location = useLocation();
    const refresh = useRefresh();
    //const form = useForm();
    const notify = useNotify();
    const [edit] = useUpdate('scheduledActivities');


    /*
    const handlePopOverClick = (event) => {
        setAnchorEl(event?.currentTarget);
    };
    */

    const handlePopOverClose = () => {
        setAnchorEl(null);
    };

    const handleCloseClick = () => {
        setshowDialog(false);
    };

    const handleClick = (event) => {
            setshowDialog(true);
/* 
        if (form.getState().dirty) {
            handlePopOverClick(event)
        } else {
            setshowDialog(true);
        } */
    };

    const handleSubmit = async values => {
        edit(
            { payload: { data: transformScheduledActivityEdit(values) } },
            {
                onSuccess: ({ data }) => {
                    setshowDialog(false);
                    refresh();
                },
                onFailure: ({ error }) => {
                    notify(error?.message, 'error');
                }
            }
        );
    };

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme?.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme?.spacing(1),
            top: theme?.spacing(1),
            color: theme?.palette?.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes?.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes?.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        !props.identity ? null : <>
            <Button
                onClick={handleClick}
                label="Editar agenda"
                icon="card-account-mail"
                disabled={props?.identity?.roles === "CONTRACTING_AUTHORITY"}
            >
                <CalendarIcon />
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopOverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Typography style={{ padding: 10 }}>Para poder editar contactos es necesario que guarde la información del formulario antes.</Typography>
            </Popover>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
            >
                <DialogTitle onClose={handleCloseClick}>Editar Agenda</DialogTitle>
                <DialogContent>
                    <SimpleForm
                        save={handleSubmit}
                        validate={ValidateEditAgenda}
                        redirect={location?.pathname}
                        mode="edit"
                        loading={props?.loading}
                        handleCloseClick={handleCloseClick}
                        initialValues={record}
                    >
                        <DateTimeInput label="Fecha de Inicio" source="startDate"></DateTimeInput>
                        <DateTimeInput label="Fecha de Fin" source="endDate"></DateTimeInput>
                    </SimpleForm>
                </DialogContent>
            </Dialog>
        </>
    )
}

const EditActivityCommentButton = (props) => {
    const [showDialog, setshowDialog] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const record = useRecordContext(props);
    const form = useForm();

    const [interactionList, setInteractionList] = useState(record?.interactions);
    const [clientAffinityList, setClientAffinityList] = useState(record?.clientAffinities);
    const [generalComment, setGeneralComment] = useState();
    const [tabValue, setTabValue] = useState(0);
    const [databaseOperationInProgress, setDataBaseOperationInProgress] = useState(false);

    const [disabledGuardar, setDisabledGuardar] = useState(false)
    const [addAffinity, setAddAffinity] = useState(false)
    //const [affinityErrors, setAffinityErrors] = useState(false);

    const handlePopOverClick = (event) => {
        setAnchorEl(event?.currentTarget);
    };

    const handlePopOverClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event, record) => {
        if (form?.getState().dirty) {
            handlePopOverClick(event)
        } else {
            record.interactions.forEach(element => {
                try {
                    element.comment = element?.comment ? atob(element?.comment) : null;
                    element.technicalComment = element?.technicalComment ? atob(element?.technicalComment) : null;
                    element.commentForRelative = element?.commentForRelative ? atob(element?.commentForRelative) : null;
                } catch (ex) { }
            });

            record.clientAffinities.forEach(element => {
                //element.id = element?.id; // No necesitas decodificar 'id' ya que es un número
                element.affinityId = decodeBase64(element?.affinityId);
                element.affinityScore = decodeBase64(element?.affinityScore);
                element.clientAId = decodeBase64(element?.clientAId);
                element.clientBId = decodeBase64(element?.clientBId);
            });

            setInteractionList(record?.interactions);
            setGeneralComment(record?.comments);
            setClientAffinityList(record?.clientAffinities);
            setshowDialog(true);
        }
    };

    const decodeBase64 = (value) => {
        try {
            // Verifica si es una cadena antes de intentar decodificarla
            return typeof value === 'string' ? atob(value) : value;
        } catch (error) {
            console.error("Error al decodificar:", error);
            return value; // Retorna el valor original si ocurre un error
        }
    };
    const onChangeGeneralComment = (value) => {
        setGeneralComment(value);
    };

    const onChangeComment = (value, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].comment = value;
        record.interactions[index].comment = value;
        setInteractionList(interactionListClone);
    };

    const onChangeTechComm = (value, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].technicalComment = value;
        record.interactions[index].technicalComment = value;
        setInteractionList(interactionListClone);
    };

    const onChangeRelativesComm = (value, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].commentForRelative = value;
        record.interactions[index].commentForRelative = value;
        setInteractionList(interactionListClone);
    };

    const onStarClickMood = (nextValue, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].mood = nextValue;
        record.interactions[index].mood = nextValue;
        setInteractionList(interactionListClone);
    };

    const onStarClickHealth = (nextValue, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].healthCondition = nextValue;
        record.interactions[index].healthCondition = nextValue;
        setInteractionList(interactionListClone);
    };
    const onStarClickFeedback = (nextValue, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].feedbackMark = nextValue;
        record.interactions[index].feedbackMark = nextValue;
        setInteractionList(interactionListClone);
    };
    const onStarClickParticipation = (nextValue, index) => {
        var interactionListClone = [...interactionList]
        interactionListClone[index].participation = nextValue?.target?.value;
        record.interactions[index].participation = nextValue?.target?.value;
        setInteractionList(interactionListClone);

    };
    // const handleSubmit = async values => {
    //     edit(
    //         {payload: {data: transformScheduledActivityEdit(values) } },
    //         {
    //             onSuccess: ({data}) => {
    //                 setshowDialog(false);
    //                 // Update the comment form to target the newly created post
    //                 // Updating the ReferenceInput value will force it to reload the available posts
    //                 // refresh();
    //                 refresh();
    //             },
    //             onFailure: ({error}) => {
    //                 notify(error.message, 'error');
    //             }
    //         }
    //     );
    // };

    const handleCloseClick = async () => {
        setDisabledGuardar(true)
        var updatedInteractionList = [];
        var updatedClientAffinityList = [];
        interactionList.forEach(element => {
            // element.comment = element?.comment ? btoaReplacement(element?.comment) : null;
            // element.technicalComment = element?.technicalComment ? btoaReplacement(element?.technicalComment) : null;
            // element.commentForRelative = element?.commentForRelative ? btoaReplacement(element?.commentForRelative) : null;
            if (!element?.mood) {
                element.mood = 0;
            }
            if (!element?.feedbackMark) {
                element.feedbackMark = 0;
            }
            if (!element?.healthCondition) {
                element.healthCondition = 0;
            }
            var updatedInteraction = new InteractionDto();
            Object.keys(element).forEach(e => {
                if (e === "creationDate") {
                    updatedInteraction[e] = null;
                } else {
                    updatedInteraction[e] = element[e];
                }
            });
            updatedInteractionList.push(updatedInteraction);
        });
        record?.clientAffinities.forEach(element => {
            var updatedClientAffinity = new ClientAffinityDto();
            Object.keys(element).forEach(e => {
                if (e === "creationDate") {
                    updatedClientAffinity[e] = null;
                } else {
                    updatedClientAffinity[e] = element[e];
                }
            });
            updatedClientAffinityList.push(updatedClientAffinity);
        });

        if (generalComment) {
            record.comments = generalComment;
        }
        setDataBaseOperationInProgress(true);
        //await scheduledActivityClient.scheduledActivityPut(transformScheduledActivityEdit(record));
        var success = false
        Promise.all([
            scheduledActivityClient?.comments({ id: record?.id, comments: generalComment || "" }),
            interactionsClient?.many(updatedInteractionList),
            affinityClient?.affinity(new CreateUpdateClientAffinityDto({ scheduledActivityId: record?.id, clientAffinities: updatedClientAffinityList }))
        ]).then(() => {
            success = true
        }).finally(() => {
            setDisabledGuardar(false)

            setDataBaseOperationInProgress(false);
            updatedInteractionList.forEach((element) => {
                element.comment = element?.comment ? (isValidBase64(element.comment) ? atob(element.comment) : element.comment) : null;
                element.technicalComment = element?.technicalComment ? (isValidBase64(element.technicalComment) ? atob(element.technicalComment) : element.technicalComment) : null;
                element.commentForRelative = element?.commentForRelative ? (isValidBase64(element.commentForRelative) ? atob(element.commentForRelative) : element.commentForRelative) : null;
            })
            setInteractionList(updatedInteractionList);
            if (success) {
                record.interactions = updatedInteractionList;
                record.clientAffinities = updatedClientAffinityList;
                setshowDialog(false);
            }
        })
    };

    function isValidBase64(str) {

        console.log(str)
        try {
            return btoa(atob(str)) === str;
        } catch (e) {
            return false;
        }
    }

    function changeTabValue(index) {
        setTabValue(index);
        console.warn("changeTab " + index);
    }

    const handleCloseDialog = () => {
        setshowDialog(false);
    }

    if (props?.loading && !props?.identity) {
        return <div></div>;
    }

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme?.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme?.spacing(1),
            top: theme?.spacing(1),
            color: theme?.palette?.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes?.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes?.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        !props?.identity ? null :
            <>
                <Button
                    onClick={(event) => handleClick(event, record)}
                    label="Editar feedback"
                    icon="card-account-mail"
                    disabled={props?.identity?.roles === "CONTRACTING_AUTHORITY" || props?.identity?.roles === "LOGISTICS_TECHNICIAN"}
                >
                    <AccountCircleIcon />
                </Button>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopOverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Typography style={{ padding: 10 }}>Para poder editar contactos es necesario que guarde la información del formulario antes.</Typography>
                </Popover>
                {/* <Dialog
                    fullWidth
                    open={showDialog}
                    onClose={handleCloseClick}
                >
                    <DialogTitle onClose={handleCloseClick}>Editar Comentario</DialogTitle>
                    <DialogContent>
                        <SimpleForm
                            save={handleSubmit}
                            validate={false}
                            redirect={location.pathname}
                            mode="edit"
                            loading={props.loading}
                            handleCloseClick={handleCloseClick}
                            initialValues={record}>
                            <RichTextInput label="" source="comments" validate={validateComment} />
                        </SimpleForm>
                    </DialogContent>
                </Dialog> */}
                <Dialog
                    fullWidth
                    open={showDialog}
                    onClose={handleCloseDialog}
                    scroll="body"
                >
                    <DialogTitle>Feedback de la Sesión</DialogTitle>

                    <DialogContent>
                        {(interactionList && interactionList?.length > 0) ?
                            <div>
                                <label style={{ fontSize: '0.7rem' }}>Comentario de la Sesión</label>
                                <ReactQuill label="Comentario" value={generalComment} onChange={(val) => onChangeGeneralComment(val)} className='generalCommentQuill' />
                                <div className="div-title-feedback">
                                    <label style={{ fontSize: '0.7rem' }}>Feedback de los Usuarios</label>
                                    {
                                        record?.participants.length > 1 && (
                                            <MUIButton
                                                style={{ backgroundColor: '#00ab8e', color: 'white', fontSize: 'small', height: "max-content" }}
                                                label="Guardar"
                                                onClick={() => setAddAffinity(!addAffinity)}
                                                disabled={disabledGuardar}
                                            >{!addAffinity ? <AddIcon style={{ marginRight: "5px" }} /> : <GroupIcon style={{ marginRight: "5px" }} />}  {!addAffinity ? " Ver o Añadir Afinidad" : " Volver a interacciones"}
                                            </MUIButton>
                                        )
                                    }
                                </div>

                                {
                                    !addAffinity ? (
                                        <>
                                            <MUITabs value={tabValue}>
                                                {interactionList.map((interaction, index) =>
                                                    <MUITab label={interaction?.client?.name + " " + interaction?.client?.surnames} onClick={() => changeTabValue(index)} />
                                                )}
                                            </MUITabs>
                                            {interactionList.map((interaction, index) =>
                                                <div
                                                    role="tabpanel"
                                                    hidden={tabValue !== index}>
                                                    <div style={{ display: 'flex', marginTop: "0.5rem" }}>
                                                        <label style={{ fontSize: '0.7rem', alignSelf: 'flex-start' }}>Detalles
                                                        </label>
                                                        <label style={{ fontSize: '0.7rem', position: 'relative', left: '29.5rem' }}>Juicio técnico
                                                        </label>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <ReactQuill className="commentQuill" value={interaction?.comment} onChange={(val) => onChangeComment(val, index)} style={{ width: '47%' }} />
                                                        <ReactQuill className="commentQuill" value={interaction?.technicalComment} onChange={(val) => onChangeTechComm(val, index)} style={{ width: '47%' }} />
                                                    </div>
                                                    {/* <div style={{ display: 'flex', marginTop: "0.5rem" }}> */}
                                                    <label style={{ fontSize: '0.7rem', marginTop: '0.5rem', alignSelf: 'flex-start' }}>Información visible por terceras partes
                                                    </label>
                                                    {/* </div> */}
                                                    {/* <div style={{ display: 'flex', justifyContent: 'center' }}> */}
                                                    <ReactQuill label="Información visible por terceras partes" className="generalCommentQuill" value={interaction?.commentForRelative} onChange={(val) => onChangeRelativesComm(val, index)} style={{ width: '100%' }} />
                                                    {/* </div> */}
                                                    <div style={{ display: 'flex' }}>
                                                        <Labeled label="Estado de ánimo">
                                                            <StarPicker style={{ marginTop: 10 }} onChange={(val) => onStarClickMood(val, index)} value={interaction?.mood}
                                                                numberStars={6} doubleTapResets size={30} />
                                                        </Labeled>
                                                        <Labeled label="Feedback sesión">
                                                            <StarPicker style={{ marginTop: 10, margingLeft: '3 rem' }} onChange={(val) => onStarClickFeedback(val, index)}
                                                                value={interaction?.feedbackMark} numberStars={6} doubleTapResets size={30} />
                                                        </Labeled>
                                                        <Labeled label="Estado físico">
                                                            <StarPicker style={{ marginTop: 20, margingLeft: '3 rem' }} onChange={(val) => onStarClickHealth(val, index)}
                                                                value={interaction?.healthCondition} numberStars={6} doubleTapResets size={30} />
                                                        </Labeled>
                                                        <SelectInput label="Participación" source={`interactions[${index}].${"participation"}`}
                                                            onChange={(val) => onStarClickParticipation(val, index)}
                                                            choices={[
                                                                { id: 'Alto', name: 'Alto' },
                                                                { id: 'Medio', name: 'Medio' },
                                                                { id: 'Bajo', name: 'Bajo' }
                                                            ]}
                                                            defaultValue={interaction.participation !== null ? interaction.participation : undefined}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : <Affinity
                                        {...props}
                                        record={record}
                                        clientAffinityList={clientAffinityList} />
                                }
                            </div> : <p>No ha habido asistentes a esta reunión</p>
                        }
                        {databaseOperationInProgress ? <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}><CircularProgress /> Por favor espere</Box> : null}
                    </DialogContent>
                    <DialogActions>
                        <MUIButton
                            style={{ backgroundColor: '#00ab8e', color: 'white' }}
                            color="primary"
                            label="Cancelar"
                            onClick={handleCloseDialog}
                        >
                            Cancelar
                        </MUIButton>
                        <MUIButton
                            //className={` ${(disabledGuardar || affinityErrors) ? "disabled-save" : ""}`}
                            style={{ backgroundColor: '#00ab8e', color: 'white' }}
                            label="Guardar"
                            onClick={handleCloseClick}
                            disabled={disabledGuardar} // Añadir affinityErrors aquí
                        >
                            Guardar
                        </MUIButton>
                    </DialogActions >
                </Dialog >
            </>
    )
}

const DeleteScheduledActivityButton = ({ record }) => {
    const location = useLocation();
    const form = useForm();
    const [anchorEl, setAnchorEl] = useState(null)

    const handlePopOverClick = (event) => {
        setAnchorEl(event?.currentTarget);
    };

    const handlePopOverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (form.getState().dirty) {
        return (
            <>
                <Button
                    onClick={handlePopOverClick}
                    label="Borrar"
                    className="my-ra-delete-button"
                    key="button"
                    color="error"
                >
                    <ActionDelete />
                </Button>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopOverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Typography style={{ padding: 10 }}>Para poder eliminar actividades de la agenda es necesario que guarde la información del formulario antes.</Typography>
                </Popover>
            </>
        )
    } else {
        return (
            <>
                <DeleteButton
                    mutationMode="pessimistic"
                    resource="scheduledActivities"
                    record={record}
                    redirect={location?.pathname}
                    label="borrar"
                >
                    <AccountCircleIcon />
                </DeleteButton>
            </>
        )
    }
};


const CancelScheduledActivityButton = ({ record, reasonForCancellationList }) => {
    const [showDialog, setshowDialog] = useState(false)
    const [disabledGuardar, setDisabledGuardar] = useState(true)
    const [selectedReason, setSelectedReason] = useState(null);
    const refresh = useRefresh();

    console.log(record?.id)
    console.log(record?.reasonForCancellationId)
    useEffect(() => {
        setDisabledGuardar(!selectedReason); // false si hay algo seleccionado
    }, [selectedReason]);

    const handleCloseClick = () => {

        console.log(selectedReason)

        if(!disabledGuardar && selectedReason){
            scheduledActivitiesProvider?.cancel(null, {id: record?.id, reasonForCancellationId: selectedReason}).then(resp => {
                setshowDialog(false);
                refresh();
            }) 
        }
        
    };

    const handleSetshowDialog = () => {
        setshowDialog(true);
    };

    const handleCloseDialog = () => {
        setshowDialog(false);
    }

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme?.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme?.spacing(1),
            top: theme?.spacing(1),
            color: theme?.palette?.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes?.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes?.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <>
            <MUIButton
                mutationMode="pessimistic"
                resource="scheduledActivities"
                record={record}
                onClick={handleSetshowDialog}
                //redirect={location?.pathname}
                label="Cancelar"
                style={{ color: "orange" }}
            >
                <CancelIcon /> <span style={{ marginLeft: "5px" }}>Cancelar</span>
            </MUIButton>

            <Dialog
                
                //style={{ width: "50%" }}
                open={showDialog}
                onClose={handleCloseDialog}
                scroll="body"
            >
                <DialogTitle>Motivo de la cancelación</DialogTitle>

                <DialogContent>
                    {
                        reasonForCancellationList ?
                            <AutocompleteInput
                                label="Motivo de cancelación"
                                source="reasonForCancellationId"
                                choices={reasonForCancellationList}
                                optionText="value"
                                optionValue="id"
                                options={{ InputProps: { autoComplete: 'off' } }}
                                resettable={true}
                                onChange={(e) => {
                                    setSelectedReason(e);
                                }}
                            />
                            : null
                    }
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        style={{ backgroundColor: '#00ab8e', color: 'white' }}
                        color="primary"
                        label="Cancelar"
                        onClick={handleCloseDialog}
                    >
                        Cancelar
                    </MUIButton>
                    <MUIButton
                        className={` ${disabledGuardar ? "disabled-save" : ""}`}
                        style={{ backgroundColor: '#00ab8e', color: 'white' }}
                        label="Guardar"
                        onClick={handleCloseClick}
                        disabled={disabledGuardar}
                    >
                        Guardar
                    </MUIButton>
                </DialogActions >
            </Dialog >
        </>
    )

};

const ActivityTypeValueInput = props => {

    const { values } = useFormState();
    const form = useForm();
    const [activityTypeValue, setactivityTypeValue] = useState();
    const [responsable, setResponsable] = useState();
    const [primeraCarga, setPrimeraCarga] = useState(true);

    useEffect(() => {
        if (values?.primaryTypeId) {
            getActivityType().then(
                res => {
                    var filtered = res?.elements?.filter(e => e?.id === values?.primaryTypeId);
                    getActivityTypeValue(filtered && filtered?.length > 0 ? filtered[0]?.code : null).then(
                        res => {
                            setactivityTypeValue(res?.elements);
                            if (primeraCarga && props.mode === 'create') {
                                setPrimeraCarga(false)
                                form.change('secondaryTypeId', null);
                            }
                            if (responsable?.role?.name === "LOGISTICS_TECHNICIAN" && !primeraCarga) {
                                let secondaryType = res.elements?.find(e => e.value.toLowerCase() === "TEST".toLowerCase())
                                form.change('secondaryTypeId', secondaryType.id);
                            }
                        }
                    )
                }
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.primaryTypeId])

    useEffect(() => {
        if (values?.professional?.id) {
            professionalClient.professionalGet(values?.professional?.id).then(p => {
                if (p?.role?.name === "LOGISTICS_TECHNICIAN" && !primeraCarga) {
                    let secondaryType = activityTypeValue?.find(e => e.value.toLowerCase() === "TEST".toLowerCase())
                    form.change('secondaryTypeId', secondaryType?.id);
                }
                setResponsable(p)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.professional?.id])

    if (!values?.primaryTypeId) return null

    return (
        <AutocompleteInput
            label="Subtipología dinámica"
            source="secondaryTypeId"
            choices={responsable?.role?.name === "LOGISTICS_TECHNICIAN" ? activityTypeValue?.filter(t => t.value.toLowerCase() === "TEST".toLowerCase()) : activityTypeValue}
            optionText="value"
            optionValue="id"
            options={{ InputProps: { autoComplete: 'off' }, autoComplete: 'off' }}
            resettable={true}
            disabled={values?.isDeleted}
            validate={[required()]}
        />
    );
};

const ContractProfessionalsInput = props => {
    const { professionalTypes } = props;
    const { values } = useFormState();
    var filterType = ['SOCIAL_WORKER', 'PSYCHOLOGIST', 'TASOC', 'THERAPIST', 'LOGISTICS_TECHNICIAN'];
    const { identity } = useGetIdentity();

    var filterId = professionalTypes?.filter(item => filterType.includes(item.value)).map(item => item.id);
    const isAdmin = identity?.roles === 'SUPER_ADMIN' || identity?.roles === 'ADMIN';

    return (
        <ReferenceInput
            label="Responsable"
            source="professional.id"
            reference="professional"
            disabled={props?.disabled}
            defaultValue={isAdmin ? undefined : identity?.professionalId}
            filter={{ type: ['SOCIAL_WORKER', 'PSYCHOLOGIST', 'TASOC', 'THERAPIST'], contractIds: values?.contracts?.map(e => e?.id) }}
            filterToQuery={(value) => {
                return { nameINumber: value, professionalTypeId: filterId }
            }}
        >
            <AutocompleteInput optionText={(record) => record?.identificationNumber + ' - ' + record?.name + ' ' + record?.surnames} resettable={true} />
        </ReferenceInput>
    );
};

const ContractParticipantsInput = props => {
    const { disabled } = props;
    const { values } = useFormState();
    const { identity, loading } = useGetIdentity();
    const [disableAdd, setDisableAdd] = useState(true)
    const [disableRemove, setDisableRemove] = useState(true)
    useEffect(() => {
        if (props?.mode && props?.mode === 'edit') {
            scheduledActivitiesProvider?.getManyReference(null, { id: values?.id, pagination: { page: 1, perPage: 100 } }).then(resp => {
                if (!resp?.data?.every(sc => !!sc?.realEndDate)) {
                    setDisableAdd(false)
                }
            })
        } else if (props?.mode && props?.mode === 'create') {
            setDisableAdd(false)
        }
        // eslint-disable-next-line
    }, [])
    useEffect(() => {
        if (props.mode && props.mode === 'edit') {
            scheduledActivitiesProvider?.getManyReference(null, { id: values?.id, pagination: { page: 1, perPage: 500 } }).then(resp => {
                if (!resp?.data?.every(sc => !!sc?.realEndDate)) {
                    setDisableAdd(false)
                }
                if (!(resp?.data && resp?.data?.length === 1 && resp?.data?.every(sc => !!sc?.realEndDate))) {
                    setDisableRemove(false);
                }
            })
        } else if (props?.mode && props?.mode === 'create') {
            setDisableAdd(false)
            setDisableRemove(false);
        }
        // eslint-disable-next-line
    }, [])

    if (loading && !identity) {
        return <div></div>;
    }


    return (
        <ArrayInput label="Participantes" source="participants" validate={[required()]} disabled={identity?.roles === "CONTRACTING_AUTHORITY" || disableAdd || disabled}>
            <SimpleFormIterator disableRemove={disableRemove || disabled} disableAdd={disableAdd || disabled}>
                <FormDataConsumer>
                    {({ scopedFormData, getSource }) => {
                        // Extraemos el índice a partir del source
                        const source = getSource('');
                        const indexMatch = source.match(/\[(\d+)\]/); // Captura el número entre corchetes

                        const index = indexMatch ? indexMatch[1] : null; // Obtenemos el índice o null si no se encuentra
                        return (
                            <div>
                                <AutoCompleteCustom
                                    type={"PARTICIPANT"}
                                    label={"Usuario"}
                                    placeholder={"Buscar participante"}
                                    disabled={disableAdd || disabled}
                                    data={scopedFormData}
                                    index={index}
                                    requiredInput={true}
                                    identity={identity}
                                    filterIds={values?.contracts?.map(e => e?.id)}
                                    {...props} />

                            </div>
                        );
                    }}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
    );
};


const ContractsInput = props => {
    const { disabled } = props;
    const { values } = useFormState();
    const { identity, loading } = useGetIdentity();
    const [disableAdd, setDisableAdd] = useState(true);
    const [disableRemove, setDisableRemove] = useState(true);

    useEffect(() => {
        if (props.mode && props.mode === 'edit') {
            scheduledActivitiesProvider?.getManyReference(null, { id: values?.id, pagination: { page: 1, perPage: 500 } }).then(resp => {
                if (!resp?.data?.every(sc => !!sc?.realEndDate)) {
                    setDisableAdd(false)
                }
                if (!(resp?.data && resp?.data?.length === 1 && resp?.data?.every(sc => !!sc?.realEndDate))) {
                    setDisableRemove(false);
                }
            })
        } else if (props?.mode && props?.mode === 'create') {
            setDisableAdd(false)
            setDisableRemove(false);
        }
        // eslint-disable-next-line
    }, [])

    if (loading && !identity) {
        return <div></div>;
    }


    return (
        <ArrayInput label="Contratos" source="contracts" id="arrayCustomContracts" validate={[required()]} disabled={disabled}>
            <SimpleFormIterator disableRemove={disableRemove || disabled} disableAdd={disableAdd || disabled}>
                <FormDataConsumer>
                    {({ scopedFormData, getSource }) => {
                        // Extraemos el índice a partir del source
                        const source = getSource('');
                        const indexMatch = source.match(/\[(\d+)\]/); // Captura el número entre corchetes

                        const index = indexMatch ? indexMatch[1] : null; // Obtenemos el índice o null si no se encuentra

                        return (
                            <div>
                                <AutoCompleteCustom
                                    type={"CONTRACTS"}
                                    label={"Contrato"}
                                    placeholder={"Buscar contrato"}
                                    disabled={disableAdd || disabled}
                                    data={scopedFormData}
                                    index={index}
                                    requiredInput={true}
                                    {...props} />


                            </div>
                        );
                    }}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
    );
};
const transformScheduledActivityEdit = (data) => {
    const startDate = data?.startDate ? moment(data?.startDate).format('yyyy-MM-DDTHH:mm:ss') : null;
    const endDate = data?.endDate ? moment(data?.endDate).format('yyyy-MM-DDTHH:mm:ss') : null;
    const activity = { id: data?.activity?.id };
    const realStartDate = data?.realStartDate ? moment(data?.realStartDate).format('yyyy-MM-DDTHH:mm:ss') : null;
    const realEndDate = data?.realEndDate ? moment(data?.realEndDate).format('yyyy-MM-DDTHH:mm:ss') : null;
    return {
        ...data,
        startDate,
        endDate,
        activity: activity,
        interactions: null,
        clientAffinity: null,
        realStartDate: realStartDate,
        realEndDate: realEndDate
    }
}

const transformActivitiesCreate = (data) => {
    // Horas a fecha null setteando horas
    let initHour = data.initHour + ':00';
    let endHour = data.endHour + ':00';

    // Pasamos fechas a formato UTC Z
    const initDate = data?.initDate ? moment(data?.initDate).format('yyyy-MM-DDTHH:mm:ss') : null;
    if (!data?.primaryTypeId) data.secondaryTypeId = null;

    return {
        ...data,
        participants: data?.participants?.map(e => e?.id),
        activityId: data?.id,
        initHour,
        endHour,
        initDate,
        professionalId: data?.professional?.id,
        //relatedContractId: data?.relatedContract?.id,
        contracts: data.contracts?.map(e => e.id)
    }
}

const transformActivitiesUpdate = (data) => {
    if (!data?.primaryTypeId) data.secondaryTypeId = null;
    return {
        ...data,
        participants: data?.participants?.map(e => e?.id),
        activityId: data?.id,
        professionalId: data?.professional?.id,
        //relatedContractId: data?.relatedContract?.id,
        contracts: data.contracts?.map(e => e.id)

    }
}

const OptionIconRenderer = choice => {
    return (
        <span>
            <FontAwesomeIcon style={{ marginRight: 10 }} icon={["fas", choice?.record?.value]} />
            {choice?.record?.value}
        </span>
    )
};